import { ServiceCategory } from 'src/common/models/serviceCategory'
import * as Styles from './styles'
import { ServiceContractError } from 'src/features/ServiceContract/state/types'
import { useSelector } from 'react-redux'
import { RootState } from 'src/state/reducer'
import { serviceLoading } from 'src/common/apiLoader/state/selection'
import { GET_SERVICE_CATEGORIES_API } from 'src/features/Service/state/actionTypes'
import InnerLoader from 'src/components/InnerLoader'
import { CategoryButton } from '../CategoryButton'
import { useState } from 'react'
import { SystemDescriptions } from 'src/common/descriptions'

export type ReduxProps = {
    serviceCategories?: ServiceCategory[],
    isGettingCategories: boolean,
    error?: ServiceContractError
}

interface Props {
    text: string
    onAccept: (category: ServiceCategory) => void
    isEmbed?: boolean
}

export const CategorySelector = (props: Props) => {

    const descriptions = SystemDescriptions.PAGES.SERVICE_CONTRACT.CREATE_SERVICE_CONTRACT

    const allCategory = {
        id: 0,
        name: descriptions.ALL,
        isActive: true,
        userId: 0,
        createdAt: '',
        updatedAt: '',
    }

    const [selectedCategory, setSelectedCategory] = useState<ServiceCategory | undefined>(allCategory)

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        serviceCategories: [
            ...state.service.serviceCategories || [],
        ],
        isGettingCategories: serviceLoading(state, [GET_SERVICE_CATEGORIES_API]),
        error: state.serviceContract.error,
    }))

    const getCategories = (): ServiceCategory[] => {
        const sortedData = reduxProps?.serviceCategories?.sort((a, b) => a.name.localeCompare(b.name)) || []

        return [
            allCategory,
            ...sortedData,
        ]
    }

    return (
        <Styles.HeaderContainer>
            <Styles.CategoriesContainer
                className='scrollable-content'
                isEmbed={props.isEmbed}
            >
                {
                    reduxProps.isGettingCategories
                        ? <InnerLoader
                            label={props.text}
                        />
                        : getCategories().map(category => <CategoryButton
                            key={category.id}
                            serviceCatgory={category}
                            onClick={(category: ServiceCategory) => {
                                setSelectedCategory(category)
                                props.onAccept(category)
                            }}
                            selected={selectedCategory?.id === category.id}
                        />)
                }
            </Styles.CategoriesContainer>
        </Styles.HeaderContainer>
    )
}
